import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2 className='text-5xl text-red-500 py-60 font-semibold text-center'>404 Page Not Found</h2>
        </div>
    );
};

export default NotFound;